import { useState } from 'react';
import { faqs } from '@/mocks/site';

const schema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map((f) => ({
    '@type': 'Question',
    name: f.q,
    acceptedAnswer: { '@type': 'Answer', text: f.a },
  })),
};

export default function FaqAccordion() {
  const [active, setActive] = useState<number>(0);

  return (
    <div>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
      />
      <div className="space-y-3">
        {faqs.map((f, i) => {
          const isOpen = active === i;
          return (
            <div
              key={f.q}
              className={`overflow-hidden rounded-lg border transition-colors ${
                isOpen ? 'border-primary-300 bg-background-100/60' : 'border-background-200 bg-background-50'
              }`}
            >
              <button
                type="button"
                onClick={() => setActive(isOpen ? -1 : i)}
                className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                aria-expanded={isOpen}
              >
                <h3 className="text-base font-semibold text-foreground-950 md:text-lg">
                  <span className="mr-2 font-brand text-primary-500">Q{i + 1}</span>
                  {f.q}
                </h3>
                <span
                  className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-background-50 transition-transform ${
                    isOpen ? 'rotate-180 bg-primary-500' : 'bg-secondary-400'
                  }`}
                >
                  <i className="ri-arrow-down-s-line text-lg" aria-hidden="true" />
                </span>
              </button>
              {isOpen && (
                <div className="border-t border-background-200 px-5 py-4">
                  <p className="text-sm leading-7 text-foreground-700">{f.a}</p>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}